exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".integral-records{padding:20px}.integral-records .search-content{margin-bottom:20px}.integral-records .search-content .search-group{display:inline-block;border:1px solid #d6d6d6;border-radius:4px}.integral-records .search-content .search-group .drop-menu-stage{border:none;width:120px;border-right:1px solid #d6d6d6;border-top-right-radius:0;border-bottom-right-radius:0}.integral-records .search-content .search-group .input-box-wrap{border:none}.integral-records .remark{width:500px;display:inline-block;padding:0;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/user/integral-records/integral-records.scss
// module id = 558
// module chunks = 2